import { Cell, flexRender } from "@tanstack/react-table";
import { cn } from "../../lib/utils";

type TableCellProps<TData extends object> = {
	cell: Cell<TData, unknown>;
};

export const DynamicDataTableCell = <TData extends object>({ cell }: TableCellProps<TData>) => {
	const meta = cell.column.columnDef.meta;
	const noTruncate = meta?.noTruncate ?? false;
	const centerItems = meta?.centerItems ?? false;
	return (
		<div
			className={cn(
				"h-full flex items-center px-[15px]",
				"[&:nth-last-child(1)]:flex-1",
				centerItems ? "justify-center" : "justify-start",
				cell.column.id === "expand" ? "px-[10px]" : "",
			)}
			style={{ width: cell.column.getSize(), minWidth: cell.column.getSize() }}
		>
			<div className={cn(!noTruncate ? "truncate" : undefined)}>
				{flexRender(cell.column.columnDef.cell, cell.getContext())}
			</div>
		</div>
	);
};
